<section class="hashtags-per-widget">
  <h3>Hashtag Name</h3>
  <ul class="hashtag-ul">
    <section *ngFor="let tag of filteredHashTags | distincthashtags">
    <li class="hashtag-li" (click)="onHashTagSelect(tag)">
      <p [highlight]="searchTerm" [text]="tag.key"></p>
    </li>
</section>
  </ul>
</section>
